// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-header {
  padding: 0.5rem 2.125rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--header-bg);
  text-transform: capitalize !important;
}
.search-header .left-block {
  display: flex;
  align-items: center;
}
.search-header .left-block .company-logo {
  color: var(--ion-color-primary-white);
}
.search-header .left-block .company-logo img {
  cursor: pointer;
  height: 40px;
  margin: 10px 0;
}
.search-header .left-block .company-name {
  font-style: normal;
  font-weight: 600;
  font-size: 1.3125rem;
  line-height: 1.5625rem;
  text-transform: uppercase;
  color: var(--ion-color-primary-black);
}
.search-header .middle-block {
  width: 55%;
  max-width: 720px;
}
.search-header .mobile-user-block-ltr img {
  min-width: 22.5px;
}
.search-header .mobile-user-block-rtl img {
  min-width: 22.5px;
}
.search-header .right-block {
  display: flex;
  align-items: center;
}
.search-header .right-block .language-select {
  margin: 0 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-header .right-block .language-select ion-select {
  color: var(--ion-color-primary-white);
  font-weight: 600;
  font-size: 0.875rem;
}
.search-header .right-block .icon-select {
  font-weight: 700;
}
.search-header .right-block .p-0 {
  padding: 0;
}
.search-header .right-block .profile-icon {
  cursor: pointer;
}
.search-header .right-block .profile-icon .profile-icon-class {
  min-width: 1.25rem;
  vertical-align: bottom;
}
.search-header .right-block .cart-icon {
  cursor: pointer;
  position: relative;
}
.search-header .right-block .cart-icon img {
  min-width: 1.5rem;
}
.search-header .right-block .cart-icon ion-badge {
  position: absolute;
  top: -10px;
  --background: var(--ion-color-secondary-orange);
  left: 1.25rem;
  border-radius: 100%;
  top: -12px;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: 0;
  --padding-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.3125rem;
  height: 1.3125rem;
  font-size: 0.75rem;
}

.main-header {
  padding: 0.8125rem 4.4375rem;
  background: var(--ion-color-primary-black);
  color: var(--ion-color-primary-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.main-header .header-left {
  display: flex;
  flex-wrap: wrap;
}
.main-header .header-left .products,
.main-header .header-left .contact-us {
  display: flex;
  cursor: pointer;
  align-items: center;
}
.main-header .header-left .products .header-menu,
.main-header .header-left .contact-us .header-menu {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  text-align: center;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.main-header .header-left .products .header-menu-visible,
.main-header .header-left .contact-us .header-menu-visible {
  color: var(--ion-app-primary);
}
.main-header .header-left .products .products-icon {
  display: flex;
}
.main-header .header-left .products .products-icon .products-list-visible {
  filter: brightness(0) saturate(100%) invert(62%) sepia(100%) saturate(302%) hue-rotate(138deg) brightness(89%) contrast(91%);
}
.main-header .header-left .products .triangle-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 1.75rem;
}
.main-header .header-left .products .triangle-icon .menu-visible {
  filter: brightness(0) saturate(100%) invert(62%) sepia(100%) saturate(302%) hue-rotate(138deg) brightness(89%) contrast(91%);
}
.main-header .header-right .location-info {
  display: flex;
}
.main-header .header-right .location-info p {
  margin: 0;
}
.main-header .header-right .location-info .location-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.main-header .header-right .location-info .current-location .current-location-name {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.main-header .header-right .location-info .current-location .change-location {
  font-weight: 400;
  font-size: 0.8125rem;
  line-height: 1.125rem;
  opacity: 0.7;
  cursor: pointer;
}
.main-header .header-right .location-info .current-location .change-location:hover {
  opacity: 1;
  color: var(--ion-app-blue);
}

.logout-icon {
  width: 1.375rem;
  cursor: pointer;
}

.contactus-icon .contact-us {
  opacity: 0.8;
}

ion-popover {
  --offset-y: 17px;
  --width: 100%;
}

.product-padding-left {
  padding-left: 2.75rem;
}

.product-padding-right {
  padding-right: 2.75rem;
}

.location-icon-padding-left {
  padding-left: 0.8125rem;
}

.location-icon-padding-right {
  padding-right: 0.8125rem;
}

.bread-crumbs {
  margin: 1.875rem 4.25rem;
}
.bread-crumbs ion-breadcrumbs ion-breadcrumb::part(separator) {
  margin: 0;
  display: none;
}
.bread-crumbs ion-breadcrumbs ion-breadcrumb::part(native) {
  padding: 0 0rem;
}

.home-bread-crumb,
.products-bread-crumb,
.bread-crumb-label,
.bread-crumb-with-url {
  font-size: 1rem;
  letter-spacing: 0;
  color: var(--ion-black-primary);
  opacity: 1;
}

.bread-crumb-with-url {
  font-size: 1rem;
  letter-spacing: 0;
  color: var(--ion-app-primary);
  opacity: 1;
}

.arrow-right-class {
  height: 0.75rem;
  padding: 0 0.3rem 0px 0.3rem;
}

@media screen and (max-width: 992px) {
  .search-header {
    padding: 0.8125rem 1.5rem 0.8125rem 0.625rem !important;
  }
  .main-header {
    padding: 0.8125rem 0.625rem;
  }
  .bread-crumbs {
    margin: 1.125rem 0.3125rem 0.8125rem !important;
  }
}
.ltr.info-dropdown {
  right: 0;
}

.rtl.info-dropdown {
  left: 0;
}

.info-dropdown {
  position: absolute;
  top: 4.6875rem;
  z-index: 999999999;
  width: 200px;
  box-shadow: 0 2.125rem 140px rgba(0, 0, 0, 0.0705882353);
}
.info-dropdown ion-label {
  font-size: 0.875rem;
  line-height: 1.625rem;
  letter-spacing: 0;
  color: var(--ion-grey1);
  opacity: 1;
}
.info-dropdown .name-class {
  text-transform: capitalize;
  font-weight: bold;
  font-size: 1.125rem;
  line-height: 1.6875rem;
  letter-spacing: 0;
  color: #434345;
  opacity: 1;
}
.info-dropdown .switch-class {
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 1.3125rem;
  letter-spacing: 0;
  color: var(--ion-app-primary);
  opacity: 1;
  margin-left: 0.625rem;
}
.info-dropdown .right-arrow {
  height: 0.625rem;
  margin-left: 0.4rem;
}

.dropdown-header {
  cursor: default;
}

.hover-item.item:hover {
  --background: var(--ion-divider) !important;
}

.web-hamburger ion-buttons {
  cursor: pointer;
}
.web-hamburger ion-buttons .web-burger-icon {
  width: 1.7rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss"],"names":[],"mappings":"AAAA;EACC,wBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kCAAA;EACA,qCAAA;AACD;AACC;EACC,aAAA;EACA,mBAAA;AACF;AACE;EACC,qCAAA;AACH;AACG;EACC,eAAA;EACA,YAAA;EACA,cAAA;AACJ;AAGE;EACC,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qCAAA;AADH;AAKC;EACC,UAAA;EACA,gBAAA;AAHF;AAOE;EACC,iBAAA;AALH;AAUE;EACC,iBAAA;AARH;AAYC;EACC,aAAA;EACA,mBAAA;AAVF;AAYE;EACC,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVH;AAYG;EACC,qCAAA;EACA,gBAAA;EACA,mBAAA;AAVJ;AAcE;EACC,gBAAA;AAZH;AAeE;EACC,UAAA;AAbH;AAgBE;EACC,eAAA;AAdH;AAgBG;EACC,kBAAA;EACA,sBAAA;AAdJ;AAkBE;EACC,eAAA;EACA,kBAAA;AAhBH;AAkBG;EACC,iBAAA;AAhBJ;AAmBG;EACC,kBAAA;EACA,UAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAjBJ;;AAuBA;EACC,4BAAA;EACA,0CAAA;EACA,qCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AApBD;AAsBC;EACC,aAAA;EACA,eAAA;AApBF;AAsBE;;EAEC,aAAA;EACA,eAAA;EACA,mBAAA;AApBH;AAsBG;;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AAnBJ;AAsBG;;EACC,6BAAA;AAnBJ;AAwBG;EACC,aAAA;AAtBJ;AAwBI;EACC,4HAAA;AAtBL;AA0BG;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAxBJ;AA0BI;EACC,4HAAA;AAxBL;AAgCE;EACC,aAAA;AA9BH;AAgCG;EACC,SAAA;AA9BJ;AAiCG;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AA/BJ;AAmCI;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AAjCL;AAoCI;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AAlCL;AAoCK;EACC,UAAA;EACA,0BAAA;AAlCN;;AA0CA;EACC,eAAA;EACA,eAAA;AAvCD;;AA2CC;EACC,YAAA;AAxCF;;AA4CA;EACC,gBAAA;EACA,aAAA;AAzCD;;AA4CA;EACC,qBAAA;AAzCD;;AA4CA;EACC,sBAAA;AAzCD;;AA4CA;EACC,uBAAA;AAzCD;;AA4CA;EACC,wBAAA;AAzCD;;AA4CA;EACC,wBAAA;AAzCD;AA6CG;EACC,SAAA;EACA,aAAA;AA3CJ;AA8CG;EACC,eAAA;AA5CJ;;AAkDA;;;;EAIC,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,UAAA;AA/CD;;AAkDA;EACC,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,UAAA;AA/CD;;AAkDA;EACC,eAAA;EACA,4BAAA;AA/CD;;AAkDA;EACC;IACC,uDAAA;EA/CA;EAkDD;IACC,2BAAA;EAhDA;EAmDD;IACC,+CAAA;EAjDA;AACF;AAoDA;EACC,QAAA;AAlDD;;AAqDA;EACC,OAAA;AAlDD;;AAqDA;EACC,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,wDAAA;AAlDD;AAoDC;EACC,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;EACA,UAAA;AAlDF;AAqDC;EACC,0BAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAnDF;AAsDC;EACC,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,UAAA;EACA,qBAAA;AApDF;AAuDC;EACC,gBAAA;EACA,mBAAA;AArDF;;AAyDA;EACC,eAAA;AAtDD;;AA0DC;EACC,2CAAA;AAvDF;;AA4DC;EACC,eAAA;AAzDF;AA2DE;EACC,aAAA;AAzDH","sourcesContent":[".search-header {\n\tpadding: 0.5rem 2.125rem;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tbackground-color: var(--header-bg);\n\ttext-transform: capitalize !important;\n\n\t.left-block {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t.company-logo {\n\t\t\tcolor: var(--ion-color-primary-white);\n\n\t\t\timg {\n\t\t\t\tcursor: pointer;\n\t\t\t\theight: 40px;\n\t\t\t\tmargin: 10px 0;\n\t\t\t}\n\t\t}\n\n\t\t.company-name {\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 1.3125rem;\n\t\t\tline-height: 1.5625rem;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t}\n\t}\n\n\t.middle-block {\n\t\twidth: 55%;\n\t\tmax-width: 720px;\n\t}\n\n\t.mobile-user-block-ltr {\n\t\timg {\n\t\t\tmin-width: 22.5px;\n\t\t}\n\t}\n\n\t.mobile-user-block-rtl {\n\t\timg {\n\t\t\tmin-width: 22.5px;\n\t\t}\n\t}\n\n\t.right-block {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t.language-select {\n\t\t\tmargin: 0 2.5rem;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\tion-select {\n\t\t\t\tcolor: var(--ion-color-primary-white);\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t}\n\t\t}\n\n\t\t.icon-select {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\t.p-0 {\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t.profile-icon {\n\t\t\tcursor: pointer;\n\n\t\t\t.profile-icon-class {\n\t\t\t\tmin-width: 1.25rem;\n\t\t\t\tvertical-align: bottom;\n\t\t\t}\n\t\t}\n\n\t\t.cart-icon {\n\t\t\tcursor: pointer;\n\t\t\tposition: relative;\n\n\t\t\timg {\n\t\t\t\tmin-width: 1.5rem;\n\t\t\t}\n\n\t\t\tion-badge {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -10px;\n\t\t\t\t--background: var(--ion-color-secondary-orange);\n\t\t\t\tleft: 1.25rem;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\ttop: -12px;\n\t\t\t\t--padding-start: 0;\n\t\t\t\t--padding-end: 0;\n\t\t\t\t--padding-top: 0;\n\t\t\t\t--padding-bottom: 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\twidth: 1.3125rem;\n\t\t\t\theight: 1.3125rem;\n\t\t\t\tfont-size: 0.75rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.main-header {\n\tpadding: 0.8125rem 4.4375rem;\n\tbackground: var(--ion-color-primary-black);\n\tcolor: var(--ion-color-primary-white);\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t.header-left {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\n\t\t.products,\n\t\t.contact-us {\n\t\t\tdisplay: flex;\n\t\t\tcursor: pointer;\n\t\t\talign-items: center;\n\n\t\t\t.header-menu {\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 0.9375rem;\n\t\t\t\tline-height: 1.125rem;\n\t\t\t\ttext-align: center;\n\t\t\t\tletter-spacing: 0.3px;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t}\n\n\t\t\t.header-menu-visible {\n\t\t\t\tcolor: var(--ion-app-primary)\n\t\t\t}\n\t\t}\n\n\t\t.products {\n\t\t\t.products-icon {\n\t\t\t\tdisplay: flex;\n\n\t\t\t\t.products-list-visible {\n\t\t\t\t\tfilter: brightness(0) saturate(100%) invert(62%) sepia(100%) saturate(302%) hue-rotate(138deg) brightness(89%) contrast(91%);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.triangle-icon {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tmin-width: 1.75rem;\n\n\t\t\t\t.menu-visible {\n\t\t\t\t\tfilter: brightness(0) saturate(100%) invert(62%) sepia(100%) saturate(302%) hue-rotate(138deg) brightness(89%) contrast(91%);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t}\n\n\t.header-right {\n\t\t.location-info {\n\t\t\tdisplay: flex;\n\n\t\t\tp {\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t.location-icon {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t}\n\n\t\t\t.current-location {\n\t\t\t\t.current-location-name {\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 0.9375rem;\n\t\t\t\t\tline-height: 1.125rem;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tletter-spacing: 0.3px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t}\n\n\t\t\t\t.change-location {\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 0.8125rem;\n\t\t\t\t\tline-height: 1.125rem;\n\t\t\t\t\topacity: 0.7;\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\tcolor: var(--ion-app-blue);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.logout-icon {\n\twidth: 1.375rem;\n\tcursor: pointer;\n}\n\n.contactus-icon {\n\t.contact-us {\n\t\topacity: .8;\n\t}\n}\n\nion-popover {\n\t--offset-y: 17px;\n\t--width: 100%;\n}\n\n.product-padding-left {\n\tpadding-left: 2.75rem;\n}\n\n.product-padding-right {\n\tpadding-right: 2.75rem;\n}\n\n.location-icon-padding-left {\n\tpadding-left: 0.8125rem;\n}\n\n.location-icon-padding-right {\n\tpadding-right: 0.8125rem;\n}\n\n.bread-crumbs {\n\tmargin: 1.875rem 4.25rem;\n\n\tion-breadcrumbs {\n\t\tion-breadcrumb {\n\t\t\t&::part(separator) {\n\t\t\t\tmargin: 0;\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\t&::part(native) {\n\t\t\t\tpadding: 0 0rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.home-bread-crumb,\n.products-bread-crumb,\n.bread-crumb-label,\n.bread-crumb-with-url {\n\tfont-size: 1rem;\n\tletter-spacing: 0;\n\tcolor: var(--ion-black-primary);\n\topacity: 1;\n}\n\n.bread-crumb-with-url {\n\tfont-size: 1rem;\n\tletter-spacing: 0;\n\tcolor: var(--ion-app-primary);\n\topacity: 1;\n}\n\n.arrow-right-class {\n\theight: 0.75rem;\n\tpadding: 0 0.3rem 0px 0.3rem;\n}\n\n@media screen and (max-width: 992px) {\n\t.search-header {\n\t\tpadding: 0.8125rem 1.5rem 0.8125rem 0.625rem !important;\n\t}\n\n\t.main-header {\n\t\tpadding: 0.8125rem 0.625rem;\n\t}\n\n\t.bread-crumbs {\n\t\tmargin: 1.125rem 0.3125rem 0.8125rem !important;\n\t}\n}\n\n.ltr.info-dropdown {\n\tright: 0;\n}\n\n.rtl.info-dropdown {\n\tleft: 0;\n}\n\n.info-dropdown {\n\tposition: absolute;\n\ttop: 4.6875rem;\n\tz-index: 999999999;\n\twidth: 200px;\n\tbox-shadow: 0 2.125rem 140px #00000012;\n\n\tion-label {\n\t\tfont-size: 0.875rem;\n\t\tline-height: 1.625rem;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--ion-grey1);\n\t\topacity: 1;\n\t}\n\n\t.name-class {\n\t\ttext-transform: capitalize;\n\t\tfont-weight: bold;\n\t\tfont-size: 1.125rem;\n\t\tline-height: 1.6875rem;\n\t\tletter-spacing: 0;\n\t\tcolor: #434345;\n\t\topacity: 1;\n\t}\n\n\t.switch-class {\n\t\tfont-weight: bold;\n\t\tfont-size: 0.875rem;\n\t\tline-height: 1.3125rem;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--ion-app-primary);\n\t\topacity: 1;\n\t\tmargin-left: 0.625rem;\n\t}\n\n\t.right-arrow {\n\t\theight: 0.625rem;\n\t\tmargin-left: 0.4rem;\n\t}\n}\n\n.dropdown-header {\n\tcursor: default;\n}\n\n.hover-item.item {\n\t&:hover {\n\t\t--background: var(--ion-divider) !important;\n\t}\n}\n\n.web-hamburger {\n\tion-buttons {\n\t\tcursor: pointer;\n\n\t\t.web-burger-icon {\n\t\t\twidth: 1.7rem;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
